import { render, staticRenderFns } from "./NotificationSection.vue?vue&type=template&id=1389269e"
import script from "./NotificationSection.vue?vue&type=script&lang=ts"
export * from "./NotificationSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports